import { UnavailableDate } from '../unavailable-date';
import { School } from '../school';
export class SchoolCalendar {
    constructor(
        public id?: number,
        public begining?: any,
        public ending?: any,
        public unavailableDates?: UnavailableDate[],
        public school?: School,
    ) {
    }

    public toString = () : string => {
        return `${this.id}: ${this.begining} - ${this.ending}`;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar.model.ts